import { useSelector } from '../Hooks';

const getLocale = () => {
  const lang = useSelector((state) => state.language);

  switch (lang) {
    case 'se':
      return 'sv';
    case 'en':
      return 'en';
    default:
      return 'en';
  }
};

export default getLocale;
